// @ts-expect-error TS(2305): Module '"react/jsx-runtime"' has no exported membe... Remove this comment to see the full error message
import { jsx as _jsx } from "react/jsx-runtime"
import { cssValue } from "./helpers"

export const Spinner = ({
  className = "",
  loading,
  size = 35,
  color,
  label
}: any) => {
  const width = cssValue(size)
  const height = cssValue(size)
  return loading
    ? _jsx(
        "span",
        {
          className: [
            className,
            "g-spinner",
            `${
              (label === null || label === void 0 ? void 0 : label.length)
                ? ""
                : "only-spinner"
            }`,
          ].join(" "),
          style: {
            width,
            height,
            borderColor: color
              ? `${color} ${color} transparent`
              : "white white transparent",
          },
        },
        void 0
      )
    : null
}
